import SweepstakesPage from 'pages/sweepstakes'
import SweepstakesRulePage from 'pages/sweepstakes/rules'
import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import LandingPage from './pages/landing'

const TermsPage = lazy(() => import('./pages/terms'))
const PrivacyPage = lazy(() => import('./pages/privacy'))

const App = () => {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          <Route path="/" exact component={LandingPage} />
          <Suspense fallback={<span></span>}>
            <Route path="/terms/" component={TermsPage} />
            <Route exact path="/sweepstakes/" component={SweepstakesPage} />
            <Route exact path="/sweepstakes/rules" component={SweepstakesRulePage} />
            <Route path="/privacy/" component={PrivacyPage} />
          </Suspense>
          <Route component={LandingPage} />
        </Switch>
      </div>
    </BrowserRouter>
  )
}

export default App
